/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { GoogleProtobufValueFromJSON, GoogleProtobufValueToJSON, StreemApiArtifactRoomOutcomeReportEntryFromJSON, StreemApiArtifactRoomOutcomeReportEntryToJSON, } from './';
export function StreemApiArtifactRoomOutcomeReportFromJSON(json) {
    return StreemApiArtifactRoomOutcomeReportFromJSONTyped(json, false);
}
export function StreemApiArtifactRoomOutcomeReportFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !exists(json, 'status') ? undefined : json['status'],
        'diagnoses': !exists(json, 'diagnoses') ? undefined : (json['diagnoses'].map(StreemApiArtifactRoomOutcomeReportEntryFromJSON)),
        'disposition': !exists(json, 'disposition') ? undefined : StreemApiArtifactRoomOutcomeReportEntryFromJSON(json['disposition']),
        'customFields': !exists(json, 'custom_fields') ? undefined : (mapValues(json['custom_fields'], GoogleProtobufValueFromJSON)),
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
export function StreemApiArtifactRoomOutcomeReportToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'diagnoses': value.diagnoses === undefined ? undefined : (value.diagnoses.map(StreemApiArtifactRoomOutcomeReportEntryToJSON)),
        'disposition': StreemApiArtifactRoomOutcomeReportEntryToJSON(value.disposition),
        'custom_fields': value.customFields === undefined ? undefined : (mapValues(value.customFields, GoogleProtobufValueToJSON)),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactRoomOutcomeReportStatus;
(function (StreemApiArtifactRoomOutcomeReportStatus) {
    StreemApiArtifactRoomOutcomeReportStatus["CAPTURED"] = "STATUS_CAPTURED";
    StreemApiArtifactRoomOutcomeReportStatus["ERROR"] = "STATUS_ERROR";
    StreemApiArtifactRoomOutcomeReportStatus["FULFILLED"] = "STATUS_FULFILLED";
    StreemApiArtifactRoomOutcomeReportStatus["REJECTED"] = "STATUS_REJECTED";
    StreemApiArtifactRoomOutcomeReportStatus["STARTED"] = "STATUS_STARTED";
    StreemApiArtifactRoomOutcomeReportStatus["UNKNOWN"] = "STATUS_UNKNOWN";
})(StreemApiArtifactRoomOutcomeReportStatus || (StreemApiArtifactRoomOutcomeReportStatus = {}));
//# sourceMappingURL=StreemApiArtifactRoomOutcomeReport.js.map